export class TimeRecordConstants {
	static readonly PENDING_OVERRIDE_THRESHOLD_MINUTES: number = 15;
	static readonly ROUND_TO_MINUTES: number = 15;
	static readonly FRIENDLY_NAME: string = "Time Record";
  static readonly REST_BREAK_DURATION_MINUTES: number = 15;
}
